import React, {useEffect} from 'react';
import moment from "moment";
let s3BaseURL = process.env.REACT_APP_S3_PUBLIC_BASE_IMAGE_URL;

function HowIdentity(props) {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);
    const element = props.value;
    return (
        <div>
            {element.map((e, index) =>
                <div className="mb-5" key={index}>
                    <div className='page-title py-3'>{e.heading}</div>
                    <div className='date mb-3'>
                        <i className="fa-regular fa-calendar-days" aria-hidden="true"/>
                        <span className='px-2'>
                            {moment(e.created_at).format("MMM D, YYYY")}
                        </span>
                    </div>
                    <img className='img-fluid w-100 mb-3' src={s3BaseURL + e.image}/>
                    <div className="content mb-3">{e.description}</div>
                    <div className="content mb-3">{e.description1}</div>
                    <div className="content mb-3">{e.description2}</div>
                    <div className="content mb-3">{e.description3}</div>
                    <div className="content mb-3">{e.description4}</div>
                    <div className="content mb-3">{e.description5}</div>
                    <div className="content mb-3">{e.description6}</div>
                    <div className="content mb-3">{e.description7}</div>
                    <div className="content mb-3">{e.description8}</div>
                    <div className="content mb-3">{e.description9}</div>
                    <div className="content mb-3">{e.description10}</div>
                    <div className="content mb-3">{e.description11}</div>
                    <div className="content mb-3">{e.description12}</div>
                    <div className="content mb-3">{e.description13}</div>
                    <div className="content mb-3">{e.description14}</div>
                </div>
            )

            }
        </div>
    );
}

export default HowIdentity;
